var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditTextIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".left-icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.30492 1.72559C8.91832 1.72559 8.60492 2.03899 8.60492 2.42559C8.60492 2.81219 8.91832 3.12559 9.30492 3.12559L10.5848 3.12559L6.83008 6.88034C6.55672 7.15371 6.55672 7.59692 6.83008 7.87029C7.10345 8.14366 7.54666 8.14366 7.82003 7.87029L11.5748 4.11556V5.39543C11.5748 5.78203 11.8882 6.09543 12.2748 6.09543C12.6614 6.09543 12.9748 5.78203 12.9748 5.39543V2.42559C12.9748 2.03899 12.6614 1.72559 12.2748 1.72559H9.30492ZM3.4999 4.20045C3.1133 4.20045 2.7999 4.51385 2.7999 4.90045V10.5005C2.7999 10.8871 3.1133 11.2005 3.4999 11.2005H9.7999C10.1865 11.2005 10.4999 10.8871 10.4999 10.5005V8.05045C10.4999 7.66385 10.8133 7.35045 11.1999 7.35045C11.5865 7.35045 11.8999 7.66385 11.8999 8.05045V10.5005C11.8999 11.6603 10.9597 12.6005 9.7999 12.6005H3.4999C2.3401 12.6005 1.3999 11.6602 1.3999 10.5005V4.90045C1.3999 3.74065 2.3401 2.80045 3.4999 2.80045H6.2999C6.6865 2.80045 6.9999 3.11385 6.9999 3.50045C6.9999 3.88705 6.6865 4.20045 6.2999 4.20045H3.4999Z",
    fill: "#266071"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditTextIcon);
export default __webpack_public_path__ + "static/media/edit_text_icon.d4031516a0ef132400de2c44696496f3.svg";
export { ForwardRef as ReactComponent };